/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 19:43:35
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:37:17
 */
const vuex_roles = JSON.parse(localStorage.getItem('vuex_roles') || '[]');
export default {
	vuex_menuList: [],
	vuex_subMenuList: [],
	vuex_ready: false,
	vuex_permissionInfo: {},
	vuex_roles,
	vuex_isshopurl: false, //是否有商团协作路由
	vuex_dictDatas: {},
};
